import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, useMemo } from 'react';

import { Opponent } from '@gem/call/CallStore/Opponent/Opponent';
import { useCallContext } from '@gem/call/CallView/CallView.context';
import { Avatar, AvatarTypes } from '@gem/call/Removable/components/Avatar/Avatar';

import styles from './NoVideoPlaceholder.styles.m.css';

interface INoVideoPlaceholderProps {
  opponent: Opponent | null;
  type: AvatarTypes;
  className?: string;
}

export const NoVideoPlaceholder: FC<INoVideoPlaceholderProps> = observer(
  ({ opponent, type, className }) => {
    const { call } = useCallContext();
    if (!opponent) {
      return null;
    }

    // TODO: выпилить и переделать на инишиал MeMember
    const avatarData = useMemo(() => {
      if (!opponent.memberDevice?.member && opponent.isMe && call.initialMeOpponentAvatar) {
        return {
          title: call.initialMeOpponentAvatar.title,
          url: call.initialMeOpponentAvatar.url,
          backgroundColorIndex: call.initialMeOpponentAvatar.colorIndex,
        };
      }
      return {
        title: opponent.memberDevice?.member.displayName,
        url: opponent.memberDevice?.member.avatarUrl,
        backgroundColorIndex: opponent.memberDevice?.member.avatarColorIndex,
      };
    }, [opponent.memberDevice?.member]);

    return (
      <Avatar
        className={classNames(styles.container, className)}
        type={type}
        title={avatarData.title}
        url={avatarData.url}
        backgroundColorIndex={avatarData.backgroundColorIndex}
      />
    );
  }
);
